import { render, staticRenderFns } from "./postType1.vue?vue&type=template&id=8bf46b3c&scoped=true&"
import script from "./postType1.vue?vue&type=script&lang=js&"
export * from "./postType1.vue?vue&type=script&lang=js&"
import style0 from "./postType1.vue?vue&type=style&index=0&id=8bf46b3c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf46b3c",
  null
  
)

export default component.exports